import { useState } from 'react'
import { Create, useTranslate } from 'react-admin'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import PersonalizationForm from './PersonalizationRuleForm'

const PersonalizationRuleCreate = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)

    return (
        <>
            <BackFromEditorButton isPristineForm={isPristineForm} backToRouteURL="/rule" />
            <Create
                title={translate(`manager.resources.${props.resource.toLowerCase()}.create`)}
                undoable={false}
                {...props}
            >
                <PersonalizationForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                />
            </Create>
        </>
    )
}

export default PersonalizationRuleCreate
